(function () {
  const colorMap = window.__themeColorPatterns || {};
  if (!Object.keys(colorMap).length) return;

  const shape = window.__themeSwatchShape || 'square';

  function slug(s) {
    return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function buildSwatch(entry) {
    let bg = '';
    if (entry.image) bg = 'url(' + entry.image + ')';
    else if (entry.color) bg = entry.color;
    if (!bg) return null;
    const span = document.createElement('span');
    span.className = 'swatch product-option__swatch product-option__swatch--' + shape;
    span.style.setProperty('--swatch--background', bg);
    return span;
  }

  function hydrateButton(btn) {
    if (btn.querySelector('.product-option__swatch')) return;
    const input = btn.querySelector('input');
    if (!input) return;
    const rawValue = input.value || input.getAttribute('aria-label');
    if (!rawValue) return;
    const entry = colorMap[slug(rawValue)];
    if (!entry) return;
    const swatchSpan = buildSwatch(entry);
    if (!swatchSpan) return;
    const label = btn.querySelector('label');
    if (!label) return;
    const textSpan = label.querySelector('span');
    if (textSpan) {
      label.insertBefore(swatchSpan, textSpan);
      textSpan.classList.add('visually-hidden');
    } else {
      label.appendChild(swatchSpan);
    }
  }

  function hydrateRoot(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches('.button--variant') && root.closest('.product-card__variants')) {
      hydrateButton(root);
      return;
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('.product-card__variants .button--variant').forEach(hydrateButton);
    }
  }

  function run() {
    hydrateRoot(document.body);
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(hydrateRoot);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }
})();
